export default __webpack_public_path__ + "static/media/head-pic.cdbc234e.png";